<template>
  <div class="edcity-add-school">
    <v-row>
      <v-col class="m-5">
        <v-text-field
          v-model="form.school_code"
          :label="labelHeader('school_code')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.school_year"
          :label="labelHeader('school_year')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.passcode"
          :label="labelHeader('passcode')"
          required
          type="password"
        ></v-text-field>
      </v-col>      
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="primary" @click="getSchoolStudentsBySchoolCode()">
          {{ $t("manage.by_edcity.list_school_students.btn.list_school_students") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-content>
            <v-data-table
              dense
              :headers="tableHeader()" 
              :items="api.edcity_students" 
              item-key="profile_id"
              :items-per-page="100">
              
            </v-data-table>
          </v-card-content>
        </v-card>
      </v-col>
    </v-row>
    <v-btn color="primary" @click="exportToCsv">
      {{ $t("manage.by_edcity.list_school_students.btn.export_to_csv") }}
    </v-btn>

  </div>
</template>

<script>
import { api_edcity } from "@/services/dds/api_edcity";
const apiEdCity = new api_edcity(process.env.VUE_APP_BASE_URL);
export default {
  name: "ListSchoolStudents",
  data: function () {
    return {
      current: {
        username: null,
        uid: null,
        user_level: null,
        auth_token: null,
      },
      form: {
        school_code: null,
        school_year: null,
        passcode: null,
      },
      api: {
        edcity_students: [],
      },
      students_header: [
        { text: 'Class Name', value: 'class_name' },
        { text: 'Class No', value: 'class_number' },
        { text: 'EN Name', value: 'student_enname' },
        { text: 'CH Name', value: 'student_chname' },
        { text: 'Reg No', value: 'reg_no' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      students_header_chi: [
        { text: '班別', value: 'class_name' },
        { text: '班號', value: 'class_number' },
        { text: '英文姓名', value: 'student_enname' },
        { text: '中文姓名', value: 'student_chname' },
        { text: '註冊編號', value: 'reg_no' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      selected_keys: [
        'hkedcity_id',
        'profile_id',
        'display_name',
        'school_code',
        'student_enname',
        'student_chname',
        'reg_no',
        'sch_year',
        'class_name',
        'class_number',
        'edcity_school_code'
      ],
    };
  },
  mounted: function () {
    var self = this;
    //self.current.school_id = self.$route.params.school_code;
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    tableHeader(label){
      var self = this;
      if(self.$i18n.locale=='tc') return self.students_header_chi;
      else return self.students_header;
    },
    labelHeader(label){
      var self = this;
      if(label=="school_code") return self.$t("manage.by_edcity.list_school_students.school_code");
      else if(label=="school_year") return self.$t("manage.by_edcity.list_school_students.school_year");
      else if(label=="passcode") return self.$t("manage.by_edcity.list_school_students.passcode");
    },
    getSchoolStudentsBySchoolCode(){
      var self = this;
      
      apiEdCity.getSchoolStudentsBySchoolCode(self.form.school_code, self.form.school_year, self.form.passcode)
      .then((response) =>{
        if(response.status=="success"){
          self.api.edcity_students = response.result;
          self.$store.commit("showSnackBar", "Students are listed");
          
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", response.message);
        }
      });
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
    jsonToCsv(jsonArray) {
      var self = this;      
      if (!jsonArray.length) return '';

      const selectedKeys = self.selected_keys;

      const csvRows = [
        selectedKeys.join(','), // Header row
        ...jsonArray.map(obj =>
          selectedKeys.map(key => {
            const val = obj[key] !== undefined && obj[key] !== null ? obj[key] : '';
            return `"${String(val).replace(/"/g, '""')}"`;
          }).join(',')
        )
      ];

      return csvRows.join('\n');
    },
    downloadCsv(filename, csvContent) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportToCsv() {
      var self = this;      
      const jsonData = self.api.edcity_students; // Your JSON array
      if (!jsonData || jsonData.length === 0){
        self.$store.commit("showSnackBar", "No students are listed");
        return;
      }
      const csv = self.jsonToCsv(jsonData);
      self.downloadCsv('students.csv', csv);
    }


  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>